<template>
    <div class="container" v-show="isShow">
        <a class="popup-close-button popup-color" @click="onCloseBtn">×</a>
        <div class="containerBody">
            <ul>
                <h3>{{ title.devText }}</h3>
                <li v-for="host in currentDatas" :key="host.id">
                    <div class="infoTitle">{{ host.label }}</div>
                    <div class="infoText"><input class="textInput" type="text" v-model="host.value" :placeholder="host.placeholder" :disabled="host.disabled"></div>
                </li>
                <li> <el-button class="saveBtn" type="success" @click="saveBtn">保存信息</el-button></li>
            </ul>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name:'AddDeviceSet',
    // props:['title'],
    data(){
        return {
            isShow:false ,
            title:{},
            ledSetData:[{id:'led001',label:'主机编码',placeholder:'请输入主机编码',value:'',disabled:false},
                        {id:'led002',label:'主机名称',placeholder:'请输入主机名称',value:'',disabled:false},
                        {id:'led003',label:'管辖路段',placeholder:'请输入管辖路段',value:'',disabled:false},
                        {id:'led004',label:'经度',placeholder:'请输入经度',value:'',disabled:false},
                        {id:'led005',label:'纬度',placeholder:'请输入纬度',value:'',disabled:false},
                        {id:'led006',label:'从机数量',placeholder:'请输入从机数量',value:'',disabled:false},
                        {id:'led007',label:'缴费地址',placeholder:'请输入缴费地址',value:'',disabled:false}],
            cameraSetData:[{id:'camera001',label:'序列号',placeholder:'请输入摄像头ID',value:'',disabled:false},
                           {id:'camera002',label:'名称',placeholder:'请输入摄像头名称',value:'',disabled:false},
                           {id:'camera003',label:'关联主机',placeholder:'请输入主机ID',value:'',disabled:false},
                           {id:'camera004',label:'取流地址',placeholder:'请输入URL',value:'',disabled:false},
                           {id:'camera005',label:'验证码',placeholder:'请输入验证码',value:'',disabled:false},
                           {id:'camera006',label:'令牌',placeholder:'请输入令牌',value:'',disabled:false},
                           {id:'camera007',label:'说明',placeholder:'请输入说明信息',value:'',disabled:false}],
            jianCeSetData:[{id:'jianCe001',label:'能见度仪ID',placeholder:'请输入能见度仪ID',value:'',disabled:false}],
            currentDatas:[],
        }
    },
    methods: {
        addDeviceTitle(title){
            this.isShow = title.isShow ;
            this.title = title ;
            if(title.id == 'device001'){
                this.ledSetData.forEach(element=>{
                    if(element.id == 'led004'){
                        element.value = this.title.lon ;
                        element.disabled = true;
                    }else if(element.id == 'led005'){
                        element.value = this.title.lat ;
                        element.disabled = true;
                    }
                })
                this.currentDatas = this.ledSetData;
            }else if(title.id == 'device002'){
                this.currentDatas = this.cameraSetData;
            }else if(title.id == 'device003'){
                this.currentDatas = '';
            }else if(title.id == 'device004'){
                this.currentDatas = '';
            }else if(title.id == 'device005'){
                this.currentDatas = this.jianCeSetData;
            }else{
                this.currentDatas = '';
            }   
        },
        saveBtn(){
            console.log('currentDatas=',this.currentDatas);
            if(this.currentDatas[0].id == 'led001'){
                this.saveLedDatas(this.currentDatas);
            }else if(this.currentDatas[0].id == 'camera001'){
                this.saveCameraDatas(this.currentDatas);
            }
            
        },
        saveLedDatas(leddatas){
            leddatas.forEach(element=>{
                if(element.value == ''){
                    alert('设备信息输入不完整，请补充完整···');
                    return 
                }
                if(element.id == 'led001'){
                    let low = element.value.slice(6,8);
                    if(element.value.length != 8){
                        alert('主机ID必须是8位16进制数');
                        return ;
                    }
                    if(low != '00'){
                        alert('主机ID最低2位必须是00');
                        return ;
                    }
                    if(/[0-9A-F]{8}/g.test(element.value)){
                        console.log('ok');
                    }else{
                        return ;
                    }
                }

                if(element.id == 'led006'){
                    if(!element.value){  element.value = 0 ;  }
                }

                let ledData = {
                    gprsAddr : leddatas[0].value ,
                    name : leddatas[1].value ,
                    clientNum : leddatas[5].value ,
                    road : leddatas[2].value ,
                    lon : leddatas[3].value ,
                    lat : leddatas[4].value ,
                    payAddr : leddatas[6].value 
                }
                // 数据保存到数据库
                this.addHostToSql(ledData);

                var url1 = "http://47.111.99.118:8089/system/addGprsReq";
                axios.get(url1).then(
                    response=>{
                        alert('AddDeviceSet 组件 设备添加--成功',response.data);
                        this.isShow = false ;
                    },
                    error=>{
                        alert('AddDeviceSet 组件 设备添加...失败',error.message);
                    }
                )
            })
        },
        saveCameraDatas(camDatas){

        },
        addHostToSql(field) { //往数据库中写入主机记录
            debugger;
            let sql = "INSERT INTO HostTable (hostID,name,clientNum,road,lon,lat,payAddr,mode,flashMode,brightness,startTime,endTime,tailSwitch,tailNum,tailDelay,uploadTime,flashRadio,batteryTime,qiXiangZhan) VALUES(";
            let hostID = "'" + field.gprsAddr + "'";
            let name = "'" + field.name + "'";
            let clientNum = field.clientNum;
            let road = "'" + field.road + "'";
            let lon = field.lon;
            let lat = field.lat;
            let payAddr = "'" + field.payAddr + "'";
            let mode = "'0'";
            let flashMode = "'关闭'";
            let brightness = "'10%'";
            let startTime = "'19:00'";
            let endTime = "'07:00'";
            let tailSwitch = "1";
            let tailNum = "'10'";
            let tailDelay = "'10'";
            let uploadTime = "'30'";
            let flashRadio = "'10'";
            let batteryTime = "'10'";
            let qiXiangZhan = "'0'";
            let dat = sql + hostID + "," + name + "," + clientNum + "," + road + "," + lon + "," + lat + "," + payAddr +
                "," + mode + "," + flashMode + "," + brightness + "," + startTime + "," + endTime + "," + tailSwitch + "," + tailNum + "," + tailDelay + "," + uploadTime + "," + flashRadio +
                "," + batteryTime + "," + qiXiangZhan + ");";
            alert(dat);
            dat += ';';

            axios.post('http://47.111.99.118:8089/system/sqlQuery',dat).then(
                response=>{
                    alert('AddDeviceSet 组件 上传--成功',response.data);
                },
                error=>{
                    alert('AddDeviceSet 组件 上传...失败',error.message);
                }
            )
        },
        onCloseBtn(){
            this.isShow = false;
        }
    },
    mounted(){
        this.$bus.on('addDeviceInfo',this.addDeviceTitle);
        console.log('AddDeviceSet组件 mounted钩子 ', this.title);
    },
    unmounted(){
        this.$bus.off('addDeviceInfo');
    }
}
</script>

<style scoped>

.container{
    position: absolute;
    width: 380px;
    height: 420px;
    top: 20%;
    left: 25%;
    color: white;
    background-color: rgba(0,0,0,.8);
    border-radius: 10px;
}
.containerBody{
    margin-top: 20px;
    height: 90%;
}
ul{
    width: 100%;
    list-style: none;
}
li{
    height: 35px;
    text-align: center;
    margin-top: 5px;
}
.infoTitle{
    width: 20%; 
    /* height: 100%;  */
    float: left; 
    margin-left: -0.5%;
    font-size: 1em;
    font-weight: 600;
}
.infoText{
    width: 80%; 
    /* height: 80%;  */
    color: white;
    margin-left: 15%;
}
.saveBtn{
    float: right;
    margin-right: 10%;
}
.popup-close-button {
    position: absolute;
    top: 5px;
    right: 5px;
    padding: 4px 4px 0 0;
    text-align: center;
    width: 18px;
    height: 14px;
    font: 16px/14px Tahoma, Verdana, sans-serif;
    text-decoration: none;
    font-weight: 700;
    background: transparent;
    z-index: 99;
  }

.popup-close-button:hover {
    cursor: pointer;
    color: red;
}
.popup-color {
    color: white;
  }
</style>